import { CHANNEL_ID } from "./const";
import { createTuituiClient } from "./sdk";

export default function createWebSocket({
  account,
  log,
  abortSignal,
  onConnected,
  onDisconnected,
  onInbounMessage,
}: any): () => void {
  const { accountId } = account;
  let closed = false;

  log?.info?.(`[${CHANNEL_ID}] AccountId: ${accountId}, starting SDK WebSocket subscription`);

  const subscription = createTuituiClient(account, log).event.subscribe({
    onConnected: () => {
      if (closed) return;
      log?.info?.(`[${CHANNEL_ID}] AccountId: ${accountId}, WebSocket connect success`);
      onConnected?.();
    },
    onDisconnected: (reason) => {
      if (closed) return;
      log?.info?.(`[${CHANNEL_ID}] AccountId: ${accountId}, WebSocket disconnected`, reason);
      onDisconnected?.(reason);
    },
    onError: (err) => {
      if (closed) return;
      log?.warn?.(`[${CHANNEL_ID}] AccountId: ${accountId}, WebSocket error: ${String(err)}`);
    },
    onRawEvent: async (raw) => {
      if (closed) return;
      log?.debug?.(`[${CHANNEL_ID}] AccountId: ${accountId}, received event ${raw.body?.event}`);
      await onInbounMessage?.(raw);
    },
  });

  const close = () => {
    if (closed) return;
    closed = true;
    subscription.unsubscribe();
  };

  if (abortSignal?.aborted) {
    close();
  } else {
    abortSignal?.addEventListener?.("abort", close, { once: true });
  }

  return close;
}
